import { createSlice } from "@reduxjs/toolkit";
import { asyncLogout, loginViaAuthToken, wrongAuthToken } from "./auth";

import Api from "../api/Api";

type State = {
  isLoading: boolean;
  error: Object | null;
  data: Object | null;
};

const INITIAL_STATE = {
  isLoading: true,
  error: null,
  data: {},
};

const currentBrand = createSlice({
  name: "currentBrand",
  initialState: INITIAL_STATE,
  reducers: {
    fetchCurrentBrandStart: (state: State) => {
      state.isLoading = true;
    },
    fetchCurrentBrandSuccess: (state: State, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchCurrentBrandFailed: (state: State, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearCurrentBrand: () => INITIAL_STATE,
  },
});

export default currentBrand.reducer;

const { fetchCurrentBrandStart, fetchCurrentBrandSuccess, fetchCurrentBrandFailed, clearCurrentBrand } = currentBrand.actions;

export const fetchCurrentBrand = (authToken?: string, navigate?: Function) => async (dispatch: Function) => {
  const urlParams = new URLSearchParams(window.location.search);
  const authValue = urlParams.get("auth");

  try {
    dispatch(fetchCurrentBrandStart());
    const api = new Api();
    const result = await api.getCurrentBrand(authToken);

    if (result.hasOwnProperty('loggedin') && !result.loggedin) {
      if (authValue) {
        dispatch(wrongAuthToken())
      } else {
        dispatch(asyncLogout());
      }
    } else {
      if (authValue) {
        dispatch(loginViaAuthToken(authValue));
      }
      dispatch(fetchCurrentBrandSuccess(result));
    }
  } catch (err : any) {
    if (authValue && err.response.status === 401) {
      dispatch(wrongAuthToken())
    } else {
      dispatch(asyncLogout());
    }
  }
};

export const clearCurrentBrandInfo = () => async (dispatch: Function) => {
  dispatch(clearCurrentBrand());
};